export default __webpack_public_path__ + "static/media/industrialist.d38380a5.png";